'use client';

import UsercentricsScriptEnabler from '@/components/usercentricsScriptEnabler/UsercentricsScriptEnabler';
import type { ComponentHeatfindWidgetStoryblok } from '@/types/component-types-sb';
import type { ImageWidthDynamic, ImageWidthStatic } from '@/types/layoutTypes';
import dynamic from 'next/dynamic';
import Script from 'next/script';
import React from 'react';

import styles from './HeatfindWidget.module.scss';

type HeatfindWidgetProps = {
  blok: ComponentHeatfindWidgetStoryblok;
  parentLayout?: ImageWidthDynamic | ImageWidthStatic;
};

function HeatfindWidgetImpl({ blok: _blok }: HeatfindWidgetProps) {
  return (
    <UsercentricsScriptEnabler id="heatfind" type="greenventory" isFullScreen={false} noWrap>
      <div className={styles.heatfindWidget}>
        <div id="greenventory" />
        <Script
          id="greenventory-widget"
          data-projectId={process.env.NEXT_PUBLIC_HEATFIND_PROJECT_ID}
          data-scenarioId={process.env.NEXT_PUBLIC_HEATFIND_SCENARIO_ID}
          data-mid={process.env.NEXT_PUBLIC_HEATFIND_MID}
          src={process.env.NEXT_PUBLIC_HEATFIND_SRC}
        />
      </div>
    </UsercentricsScriptEnabler>
  );
}

/**
 * `ssr: false` must run inside a Client Component, not in `components.main.map.ts` (server).
 */
const HeatfindWidget = dynamic(() => Promise.resolve({ default: HeatfindWidgetImpl }), {
  ssr: false,
});

export default HeatfindWidget;
